export default "__VITE_ASSET__hvX409pI__"